module.exports = __webpack_public_path__ + "static/media/new_identification_card_back.56e9683a.svg";